import React, { useEffect, useState } from "react";
import { Typography, Card } from "@mui/material";
import { getTokenizationKeyCustomer } from "../../../../plugins/ApiHandler";
import {
  cleanupPaymentMethods,
  loadGooglePayScript,
} from "../../../../plugins/helpers";

const GooglePayPayment = ({ paymentFormik, CustomerId }) => {
  const [publicKey, setPublicKey] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadGooglePay = async () => {
      try {
        cleanupPaymentMethods();

        const response = await getTokenizationKeyCustomer(CustomerId);
        
        if (response?.PublicKey && response.PublicKey.trim() !== "") {
          setPublicKey(response.PublicKey);
          await loadGooglePayScript(response.PublicKey, paymentFormik);
          setLoading(false);
          setError(""); // Clear any previous errors
        } else {
          setLoading(false);
          setError("No public key available for Google Pay");
        }
      } catch (error) {
        setLoading(false);
        setError(error?.message || "Failed to load Google Pay");
      }
    };

    const hasCustomerId = CustomerId && CustomerId.trim() !== "";
    const hasAmount =
      paymentFormik?.values?.amount &&
      parseFloat(paymentFormik.values.amount) > 0;

    if (!hasCustomerId) {
      setLoading(false);
    } else if (!hasAmount) {
      setLoading(false);
    } else {
      loadGooglePay();
    }

    return () => {
      cleanupPaymentMethods();
    };
  }, [CustomerId, paymentFormik?.values?.amount]);

  if (loading) {
    return (
      <Card
        style={{ padding: "16px", background: "#F8FAFC", borderRadius: "12px" }}
      >
        <Typography style={{ color: "#0f2b46", textAlign: "center" }}>
          Loading Google Pay...
        </Typography>
      </Card>
    );
  }

  if (window.location.protocol !== "https:") {
    return (
      <Card
        style={{ padding: "16px", background: "#F8FAFC", borderRadius: "12px" }}
      >
        <Typography style={{ color: "red", textAlign: "center" }}>
          Google Pay requires HTTPS
        </Typography>
      </Card>
    );
  }

  if (!publicKey) {
    return (
      <Card
        style={{ padding: "16px", background: "#F8FAFC", borderRadius: "12px" }}
      >
        <Typography style={{ color: "red", textAlign: "center" }}>
          Google Pay not available
        </Typography>
      </Card>
    );
  }

  if (error) {
    return (
      <Card
        style={{ padding: "16px", background: "#F8FAFC", borderRadius: "12px" }}
      >
        <Typography style={{ color: "red", textAlign: "center" }}>
          {error}
        </Typography>
      </Card>
    );
  }

  return (
    <Card
      style={{ padding: "16px", background: "#F8FAFC", borderRadius: "12px" }}
    >
      <Typography
        style={{
          color: "#0f2b46",
          fontWeight: "600",
          fontSize: "16px",
          marginBottom: "16px",
        }}
      >
        Google Pay
      </Typography>

      <div className="google-pay-button"></div>

      <Typography
        style={{
          color: "#6B7280",
          fontSize: "12px",
          marginTop: "8px",
          textAlign: "center",
        }}
      >
        Secure payment powered by Google Pay
      </Typography>
    </Card>
  );
};

export default GooglePayPayment;
